<template>
    <div class="modal-backdrop">
        <div class="modal-content">
            <div class="wrapper w-100">
                <div class="flex-column align-center w-100 max-w-540">
                    <img src="https://static.toss.im/lotties/error-spot-no-loop-space-apng.png" width="160"
                        height="160">
                    <h2 class="title">{{ title }}</h2>
                    <div class="w-100 button-group">
                        <a class="btn" @click="toPaymentHistory">돌아가기</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                errorCode: null,
                errorMessage: null,
                title: "결제를 실패했어요",
            }
        },
        methods: {
            parseQueryParams() {
                const urlParams = new URLSearchParams(window.location.search);
                const errorCode = urlParams.get("code");
                const errorMessage = urlParams.get("message");

                this.errorCode = errorCode;
                this.errorMessage = errorMessage;
            },

            toPaymentHistory() {
                this.$router.replace('/payments');
            },
        },
    }
</script>

<style scoped>

    /* ****************** layout ****************** */
    .w-100 {
        width: 100%;
    }

    a {
        text-decoration: none;
        text-align: center;
    }

    .wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px;
        overflow: auto;
    }

    .max-w-540 {
        max-width: 540px;
    }

    .flex {
        display: flex;
    }

    .flex-column {
        display: flex;
        flex-direction: column;
    }

    .justify-between {
        justify-content: space-between;
    }

    .align-center {
        align-items: center;
    }

    /* ****************** button ****************** */
    .btn {
        padding: 11px 22px;
        border: none;
        border-radius: 8px;

        background-color: #f2f4f6;
        color: #4e5968;
        font-weight: 600;
        font-size: 17px;
        cursor: pointer;
    }

    .button-group {
        margin-top: 32px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 16px;
    }

    /* ****************** text ****************** */
    .title {
        margin-top: 32px;
        margin-bottom: 0;
        color: #191f28;
        font-weight: bold;
        font-size: 24px;
    }

    /* ****************** modal ****************** */
    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
    }

    .modal-content {
        background-color: white;
        border-radius: 8px;
        min-width: 550px;
        max-width: 800px;
        min-height: 40%;
        max-height: 50%;
        overflow-y: hidden;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }
</style>